import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

//traders
const TradersInvestment = Loadable(lazy(() => import("pages/traders/Investment")));
const TradersInvestmentReturn = Loadable(lazy(() => import("pages/traders/InvestmentReturn")));
const Report = Loadable(lazy(() => import("pages/traders/Report")));

const TradersRoutes = {
  path: "traders",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "investment",
      element: <TradersInvestment />,
    },
    {
      path: "return-investment",
      element: <TradersInvestmentReturn />,
    },
    {
      path: "report",
      element: <Report />,
    },
  ],
};

export default TradersRoutes;
